import { CubeTexture } from '@babylonjs/core/Materials/Textures/cubeTexture'
import ModelViewer from '../ModelViewer'

const speed = 0.001
let _viewer: ModelViewer
let x = 0

export function setMovingLightEnabled(viewer: ModelViewer, enable: boolean) {
	_viewer = viewer
	if (enable) {
		viewer.scene.registerBeforeRender(rotateLights)
	} else {
		viewer.scene.unregisterBeforeRender(rotateLights)
	}
}

function rotateLights(): void {
	x += speed
	;(_viewer.scene.environmentTexture as CubeTexture).rotationY = Math.sin(x)
}

export function fadeLightsDown(_viewer: ModelViewer) {
	// new AnimationTimer(_viewer.scene, { target: _viewer.imageProcessing, property: "exposure", from: _viewer.pipeline.imageProcessing.exposure, to: 0})
}
export function fadeLightsUp(_viewer: ModelViewer) {
	// new AnimationTimer(_viewer.scene, { target: _viewer.pipeline.imageProcessing, property: "exposure", from: _viewer.pipeline.imageProcessing.exposure, to: 1})
}
